import State from "slotworks/state-machine/states/state";
import gateway from "components/gateway";
import gameState from "slotworks/model/game-state";
import GatewayResult from "model/gameplay/records/results/gateway-result";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import Components from "slotworks/components/components";
import { Services } from "slotworks/services/services";
import Layers from "slotworks/graphics/layers/layers";
import {LLCustomLayers} from "../../../lib/luck-and-luxury/src/names";

export default class CGGatewayBonus extends State {
    public onEnter() {

        const record = gameState.getCurrentGame().getRootRecord();
        const gatewayResult = record.getResultsOfType(GatewayResult)[0];

        const gameplay = gameState.getCurrentGame();
        Services.transaction.setWinnings(gameplay.getTotalWin()).execute();

        smartUiFlags.set(SmartUIFlag.BONUS, true);

        lightningBorderAnimationUtil.stop();

        Components.footer.showMiscWin("lbl.sca");

        if (Layers.Background.hasScene("pick_bonus")) {
            Layers.Background.setScene("pick_bonus").execute();
        }
        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("pick_bonus")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("pick_bonus").execute();
        }

        gateway.playAnimation(gatewayResult).then(() => this.complete());
    }

    public onExit() {
        smartUiFlags.set(SmartUIFlag.BONUS, false);

        if (Layers.Background.hasScene("default")) {
            Layers.Background.setScene("default").execute();
        }
        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("default")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("default").execute();
        }
    }
}
